import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "Our refund policy",
    paragraphs: [
      "BuildOnce Studio is committed to providing a quality product and a fair purchasing experience. Please read this policy carefully before completing your purchase.",
    ],
  },
  {
    heading: "Digital product. No refunds once accessed",
    paragraphs: [
      "The BuildOnce Clarity Kit is a digital product delivered immediately upon payment. No refunds will be issued once the Clarity Kit has been accessed via your access link. This policy applies to all purchases at both the founding price (SGD 97) and the standard price (SGD 149).",
      "This policy is consistent with the Consumer Protection (Fair Trading) Act (Singapore) as it applies to digital goods that are supplied immediately and have been fully accessed by the purchaser.",
      "By clicking your access link and entering the Clarity Kit, you confirm that you have received the digital product and that delivery is complete.",
    ],
  },
  {
    heading: "Exceptions. Technical issues",
    paragraphs: [
      "BuildOnce Studio will review refund requests only in the following circumstances:",
    ],
    bullets: [
      "The Clarity Kit is inaccessible due to a verified technical fault on BuildOnce Studio's end (not caused by the purchaser's device, browser, or internet connection).",
      "You were charged multiple times for the same purchase due to a payment processing error.",
    ],
    note: "To request a review, email info@buildoncestudio.com within 7 days of purchase. Include your name, the email address used at checkout, the date of purchase, and a description of the technical issue including any error messages or screenshots. Approved exception refunds will be processed within 5 to 10 business days to the original payment method.",
  },
  {
    heading: "Purchases made in error",
    paragraphs: [
      "If you purchased the Clarity Kit in error and have not yet accessed your access link, contact info@buildoncestudio.com within 24 hours of purchase. We will review your request on a case-by-case basis.",
      "Once the access link has been clicked, the product is considered accessed and the standard no-refund policy applies.",
    ],
  },
  {
    heading: "Chargebacks and payment disputes",
    paragraphs: [
      "If you initiate a chargeback or payment dispute through your bank or card provider without first contacting BuildOnce Studio, we reserve the right to revoke your access to the Clarity Kit immediately and provide evidence of purchase and delivery to the payment processor to contest the chargeback.",
      "We strongly encourage you to contact us directly at info@buildoncestudio.com before raising a dispute with your bank.",
    ],
  },
  {
    heading: "Currency and pricing",
    paragraphs: [
      "All prices are listed in Singapore Dollars (SGD). Payment is processed by Stripe. The SGD amount charged will appear on your bank or card statement, though your bank may apply its own foreign exchange conversion if your account is held in another currency.",
    ],
  },
  {
    heading: "Questions",
    paragraphs: [
      "Email: info@buildoncestudio.com · Response time: within 2 business days.",
      "BuildOnce Studio · UEN: 53518159X · Singapore",
    ],
  },
];

export default function RefundPolicy() {
  return (
    <LegalLayout
      testId="refund-policy-page"
      eyebrow="Legal · Refunds"
      title="Refund Policy."
      intro="BuildOnce Studio's policy on refunds and disputes for digital products."
      sections={sections}
    />
  );
}
